/**
 * Vanilla version of the Lodash _.groupBy function.
 *
 * Creates an object composed of keys generated from the results of running each element of
 * the array using the key. The order of grouped values is determined by the order they occur in
 * the array. The corresponding value of each key is an array of elements.
 *
 * @param arr - The array to iterate over.
 * @param key - The iteratee to transform keys.
 * @returns object
 */
export const groupBy = (arr, key) => {
  return arr.reduce((storage, item) => {
    const group = item[key];
    storage[group] = storage[group] || [];
    storage[group].push(item);
    return storage;
  }, {});
};
